import React from 'react';

import UserFilter from 'components/Filters/UserFilter';

import { Filter } from '@gogame/filters';

import {
  FILTER_CREATED,
  FILTER_ACTIVITY,
  FILTER_ACTIVITY_TYPES,
  FILTER_STATUSES,
  FILTER_APPLICATIONS,
  FILTER_PLATFORMS,
  FILTER_REWARDS,
  FILTER_REQUESTED_BY,
  FILTER_DEPENDENCIES,
  ADDED_PERIOD_PRESETS,
  ACTIVITY_PERIOD_PRESETS,
  FILTER_ATTRIBUTION,
  FILTER_TYPES,
  FILTER_REWARDS_TYPES,
} from 'scenes/PromoCodes/constants';
import {
  loadReAttrs,
  loadTypes,
  loadStatuses,
  loadApplications,
  loadPlatforms,
  loadRewards,
  loadRequestedBy,
  loadActivityTypes,
  loadRewardTypes,
} from 'scenes/PromoCodes/sources/filters';

const CreatedFilter = (props) => (
  <Filter.DateRangePicker
    title={'Added'}
    placeholder={'All'}
    name={FILTER_CREATED}
    presets={ADDED_PERIOD_PRESETS}
    {...props}
  />
);

const ActivityFilter = (props) => (
  <Filter.DateRangePicker
    title={'Activity Period'}
    placeholder={'All'}
    name={FILTER_ACTIVITY}
    presets={ACTIVITY_PERIOD_PRESETS}
    {...props}
  />
);

export const TypesFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Types'}
      name={FILTER_TYPES}
      source={loadTypes}
      placeholder={'All'}
      {...props}
    />
  );
};

export const RewardTypesFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Rewards types'}
      name={FILTER_REWARDS_TYPES}
      source={loadRewardTypes}
      placeholder={'All'}
      {...props}
    />
  );
};

export const AttributionFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Attribution'}
      name={FILTER_ATTRIBUTION}
      source={loadReAttrs}
      placeholder={'All'}
      {...props}
    />
  );
};

export const ActivityTypesFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Activity Types'}
      name={FILTER_ACTIVITY_TYPES}
      source={loadActivityTypes}
      placeholder={'All'}
      {...props}
    />
  );
};

export const StatusesFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Statuses'}
      name={FILTER_STATUSES}
      source={loadStatuses}
      placeholder={'All'}
      {...props}
    />
  );
};

export const ApplicationsFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Applications'}
      name={FILTER_APPLICATIONS}
      source={loadApplications}
      placeholder={'All'}
      {...props}
    />
  );
};

export const PlatformsFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Platforms'}
      name={FILTER_PLATFORMS}
      source={loadPlatforms}
      placeholder={'All'}
      {...props}
    />
  );
};

export const RewardsFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Rewards'}
      name={FILTER_REWARDS}
      source={loadRewards}
      placeholder={'All'}
      depends={FILTER_DEPENDENCIES[FILTER_REWARDS]}
      {...props}
    />
  );
};

export const RequestedByFilter = (props) => {
  return (
    <UserFilter
      title={'Requested by'}
      name={FILTER_REQUESTED_BY}
      source={loadRequestedBy}
      placeholder={'All'}
      {...props}
    />
  );
};

export default {
  Created: CreatedFilter,
  Activity: ActivityFilter,
  Attribution: AttributionFilter,
  Types: TypesFilter,
  RewardsTypes: RewardTypesFilter,
  ActivityTypes: ActivityTypesFilter,
  Statuses: StatusesFilter,
  Applications: ApplicationsFilter,
  Platforms: PlatformsFilter,
  Rewards: RewardsFilter,
  RequestedBy: RequestedByFilter,
};
